<template>
  <div>
    <HeroBanner :page="'matchs'"/>

    <!--MatchFilters/-->

    <section>
      <MatchList/>
      <LoggedInDisplayer/>
    </section>
  </div>
</template>

<script>
import LoggedInDisplayer from '@/components/LoggedInDisplayer'
import HeroBanner from '@/components/HeroBanner'
import NewTournamentButton from '@/components/NewTournamentButton'
import NewMatchButton from '@/components/NewMatchButton'
import NewMatchForm from '@/components/NewMatchForm'
import MatchList from '@/components/MatchList'
import MatchFilters from '@/components/MatchFilters'
export default {
  components: {
    LoggedInDisplayer,
    HeroBanner,
    NewTournamentButton,
    NewMatchButton,
    NewMatchForm,
    MatchList,
    MatchFilters
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageMatchList.vue